import { render, staticRenderFns } from "./create-modal.vue?vue&type=template&id=3cde892a&scoped=true"
import script from "./create-modal.vue?vue&type=script&lang=ts"
export * from "./create-modal.vue?vue&type=script&lang=ts"
import style0 from "./create-modal.vue?vue&type=style&index=0&id=3cde892a&prod&lang=scss&scoped=true"
import style1 from "./create-modal.vue?vue&type=style&index=1&id=3cde892a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cde892a",
  null
  
)

export default component.exports